module.exports = __webpack_public_path__ + "assets/img/campaign-image-3.cd1cadeb.png";